import { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faReceipt } from '@fortawesome/free-solid-svg-icons'
import { printPrice } from '../../utils/functions'
import { useAppSelector } from '../../store/hooks'
import PropTypes from 'prop-types'

export default function OrdensPrint(props) {
  const { cartShopping, widthPrinter } = props

  const layout = widthPrinter === 48 ? '200px' : '320px'
  const numberLines = widthPrinter === 48 ? 20 : 30

  const coverWithCaracter = (caracter, factor = 1) => {
    let text = ''
    for (let index = 0; index < numberLines * factor; index++) {
      text += caracter
    }
    return text
  }

  const { business } = useAppSelector((state) => state.init)

  const componentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  return (
    <>
      <div className="mb-5 mt-8 flex items-center justify-between px-4 sm:px-6 lg:px-8">
        <h2 className="text-lg font-medium text-gray-900">
          Comprobante de compra
        </h2>
      </div>

      {cartShopping.length === 0 ? (
        <div className="text-center">
          <FontAwesomeIcon
            aria-hidden="true"
            className="mt-3 h-16 w-16 text-gray-500"
            icon={faReceipt}
          />
          <h3 className="mt-2 text-sm font-medium text-gray-500">
            No tienes productos en tu tique.
          </h3>
        </div>
      ) : (
        <div className="mx-5">
          <div ref={componentRef} style={{ width: layout }}>
            <div className=" ">
              <p className="mb-3 mt-2 text-center font-medium underline underline-offset-8">
                {business.name}
              </p>
              <table className="divide-y">
                <tbody>
                  <tr>
                    <td className={`text-sm`}>
                      <div className="font-medium">08/11/2022 7:35am</div>
                    </td>

                    <td className={`py-1 pr-4 text-right text-sm font-medium`}>
                      #8-Mesa 4
                    </td>
                  </tr>
                  <tr className="text-center">
                    <td className="text-sm" colSpan={2}>
                      {coverWithCaracter('=')}
                    </td>
                  </tr>
                  {cartShopping.map((product) => (
                    <tr key={`${product.name}-${product.quantity}`}>
                      <td className={`text-sm`}>
                        <div className="font-medium">
                          {'(x' + product.quantity + ')' + ' ' + product.name}
                        </div>
                      </td>
                      <td
                        className={`py-1 pr-4 text-right text-sm font-medium`}
                      >
                        {printPrice(product?.price.price)}
                      </td>
                    </tr>
                  ))}
                  <tr className="text-center">
                    <td className="text-sm" colSpan={2}>
                      {coverWithCaracter('-', 1.5)}
                    </td>
                  </tr>
                  <tr className="mt-2">
                    <td className="py-1 pt-2 text-sm">
                      <div className="font-medium uppercase">Importe:</div>
                    </td>

                    <td className="py-1 pr-4 text-right text-sm font-medium">
                      4585.00 CUP
                    </td>
                  </tr>
                  <tr className="mt-1">
                    <td className="text-sm">
                      <div className="font-medium uppercase">Subtotal:</div>
                    </td>

                    <td className="pr-4 text-right text-sm font-medium">
                      4585.00 CUP
                    </td>
                  </tr>
                  <tr className="mt-1">
                    <td className="text-sm">
                      <div className="font-medium uppercase">Descuento:</div>
                    </td>

                    <td className="pr-4 text-right text-sm font-medium">
                      0.00 CUP
                    </td>
                  </tr>
                </tbody>
              </table>

              <p className="mt-2 text-center font-medium">
                {business.footerTicket}
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 px-4 py-6 sm:px-6">
            <button
              className={
                'w-full rounded-md border border-transparent bg-orange-500 px-4 py-3 ' +
                'text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2' +
                ' focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-gray-50 hover:bg-orange-700'
              }
              onClick={handlePrint}
              type="button"
            >
              Imprimir
            </button>
          </div>
        </div>
      )}
    </>
  )
}

OrdensPrint.propTypes = {
  cartShopping: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      price: PropTypes.shape({
        price: PropTypes.number.isRequired,
      }).isRequired,
    })
  ).isRequired,
  widthPrinter: PropTypes.number.isRequired,
}
